/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import Switch from "react-switch";

export default class DepositSelector extends React.Component {
  constructor(props) {
    super(props);

    if (
      !this.props.selectedDepositTypes ||
      !Array.isArray(this.props.selectedDepositTypes)
    ) {
      this.updateValue([]);
      return;
    }

    const permittedDepositTypes = this.props.selectedDepositTypes.filter(e =>
      this.props.allDepositTypes.includes(e),
    );
    if (
      permittedDepositTypes.length !== this.props.selectedDepositTypes.length
    ) {
      this.updateValue(permittedDepositTypes);
    }
  }

  handleChange(depositType, isChecked) {
    if (isChecked) {
      this.updateValue([...this.props.selectedDepositTypes, depositType]);
    } else {
      this.updateValue(
        this.props.selectedDepositTypes.filter(e => e !== depositType),
      );
    }
  }

  updateValue(selectedDepositTypes) {
    this.props.onChange({
      target: {
        value: selectedDepositTypes,
      },
    });
  }

  render() {
    const { props } = this;
    const { allDepositTypes, selectedDepositTypes } = props;

    if (!allDepositTypes) {
      return null;
    }

    return (
      <div>
        {allDepositTypes.map(depositType => {
          return (
            <label
              key={`pt-${depositType}`}
              htmlFor={`pts-${depositType}`}
              className="order-unit-pfand-type"
            >
              <Switch
                onChange={isChecked => {
                  this.handleChange(depositType, isChecked);
                }}
                checked={(selectedDepositTypes || []).includes(depositType)}
                uncheckedIcon={false}
                height={18}
                width={40}
                activeBoxShadow="none"
                id={`pts-${depositType}`}
              />
              <span
                onClick={() => {
                  this.handleChange(
                    depositType,
                    !(selectedDepositTypes || []).includes(depositType),
                  );
                }}
              >
                {depositType}
              </span>
            </label>
          );
        })}
      </div>
    );
  }
}
